import { memo, useTransition } from "react";
import { useLocation, useNavigate } from "react-router-dom";


const NavLinkTransition = memo(
  ({ to, label, navKey, activeNav, setActiveNav, setMobileToggle }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isPending, startTransition] = useTransition();

    const handleClick = (e) => {
      e.preventDefault();

      // If already on the same route → smooth scroll to top
      if (location.pathname === to) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      // Update active nav + close mobile menu
      setActiveNav(navKey);
      setMobileToggle(false);

      // Navigate inside transition
      startTransition(() => {
        navigate(to);
      });
    };

    const isActive = activeNav === navKey;

    return (
      <li
        className={`cursor-pointer ${
          isActive ? "text-[#307bc4] font-bold" : ""
        }`}
      >
        <a
          href={to}
          onClick={handleClick}
          className={`transition-opacity duration-200 ${
            isPending ? "opacity-70" : ""
          }`}
          aria-current={isActive ? "page" : undefined}
        >
          {label}
        </a>
      </li>
    );
  }
);

export default NavLinkTransition